<div *ngIf="chips.length">
  <hero-chips [items]="chips"
    (removeItem)="onRemove($event)"></hero-chips>
</div>